import { render } from "./OwnersList.vue?vue&type=template&id=f1a6f75a"
import script from "./OwnersList.vue?vue&type=script&lang=js"
export * from "./OwnersList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__